var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.19504 6.50139C10.81 3.10133 19.1065 4.03289 24.8011 9.3C25.0613 9.54062 25.0664 9.94805 24.8152 10.1977L23.4777 11.5246C23.2379 11.7625 22.8519 11.768 22.6027 11.5395C18.2816 7.58073 12.1781 6.62313 6.99456 8.66512L4.19504 6.50139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.91361 7.89817C1.32037 8.32521 0.747486 8.79248 0.198795 9.3C-0.0613614 9.54062 -0.0664395 9.94805 0.185123 10.1977L1.52262 11.5246C1.76247 11.7629 2.1484 11.768 2.39762 11.5395C3.06699 10.9262 3.77916 10.385 4.52409 9.91578L1.91361 7.89817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19604 11.9809C6.26806 12.4382 5.38818 13.0228 4.58317 13.7348C4.31364 13.973 4.30504 14.3867 4.5609 14.6391L5.90622 15.9668C6.14059 16.198 6.51793 16.2137 6.76754 15.998C7.75389 15.1454 8.8881 14.5498 10.081 14.2107L7.19604 11.9809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8728 13.9812C15.4455 14.2277 16.9624 14.9004 18.232 15.998C18.4816 16.2137 18.8589 16.1984 19.0933 15.9668L20.4386 14.6391C20.6949 14.3867 20.6859 13.9727 20.4168 13.7348C17.5064 11.161 13.6218 10.2527 10.0239 11.0065L13.8728 13.9812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 19.5C9.99997 18.1191 11.1191 17 12.5 17C13.8808 17 15 18.1191 15 19.5C15 20.8809 13.8808 22 12.5 22C11.1191 22 9.99997 20.8809 9.99997 19.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.224 21.8687L0.241255 4.10562C-0.0310137 3.8939 -0.0802331 3.50132 0.131488 3.22866L0.898685 2.24154C1.11041 1.96888 1.50338 1.91966 1.77604 2.13177L24.7587 19.8949C25.031 20.1066 25.0802 20.4992 24.8685 20.7718L24.1013 21.759C23.8896 22.0316 23.4966 22.0804 23.224 21.8687Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.3d8e0a9415c076f3fd253eceb2ec9704.svg";
export { ForwardRef as ReactComponent };